

































































































































































import Vue from 'vue';
import LiquorTree from 'liquor-tree';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';
import { TreeViewHeader } from '@/components/shared';
import { TreeViewHelpers } from '@/mixins/treeView';
import MStoreTable from '@/components/shared/Table/MStoreTable.vue';
import MStoreFormCheckbox from '@/components/shared/MStoreFormCheckbox.vue';
import MStoreFilter from '@/components/shared/MStoreFilter.vue';
import {
  BaseDocumentSearchModel,
  Cabinet,
  DocumentsToStore,
  DocumentTypes,
  NotificationConstants,
  DataLookupState,
  StickyStoreNames,
  StickySettingsActions,
  StickySettingsGetters,
  StickySettingsFields,
  MStoreExceptionResponseModel,
  HttpResponseCodeConstants,
  ConfirmationModalSettings,
  InformationModalSettings,
  DocumentToStoreUploadModel,
  ColourVariantType,
  NotificationPresentationType,
  MStoreConstants
} from '@/types';
import { mapActions, mapGetters } from 'vuex';
import { DocumentsToStoreService } from '@/services';
import SnotifyConfiguration from '@/classes/SnotifyConfiguration';
import { ModalHelpers } from '@/mixins';
import { SelectableTableUtils } from '@/utils';
import { DocumentsToStoreBulkDeleteRequestModel, NotificationModel } from '@/services/GeneratedApi';
import ApiConfiguration from '@/classes/ApiConfiguration';
import MStoreProgressModal from '@/components/shared/MStoreProgressModal.vue';
import { confirmationHelper } from '@/mixins/confirmationHelper';

Vue.use(LiquorTree);

Vue.filter('kb', (val: any) => {
  return Math.floor(val / 1024);
});

interface FileUploadModel {
  file: any;
  type: any;
  progress: number;
}

export default Vue.extend({
  name: 'DocumentsToStoreTreeView',
  mixins: [TreeViewHelpers, ModalHelpers, confirmationHelper],
  props: {
    loading: {
      type: Boolean,
      required: false
    }
  },
  data() {
    return {
      permissionData: null,
      options: {
        checkbox: false,
        parentSelect: true
      },
      documentType: {},
      documentData: [],
      documentColumns: [],
      isDataLoading: false,
      dynamicTreeData: [],
      supportedFiles: [] as FileUploadModel[],
      max: 100,
      showFileUploadModal: false,
      buttonDragover: false,
      gridDragover: false,
      sortProperties: {},
      selectedDocument: null,
      filteredItems: [],
      selectedDocumentType: null,
      documentsToStoreDocumentTypeId: null,
      showFilters: false,
      searchQuery: '',
      selectedNodeText: '',
      selectedDocumentIds: [] as string[],
      showBulkDeleteModal: false
    };
  },
  methods: {
    ...mapActions('documentViewStore', ['loadPage', 'setDocumentSearchModel', 'unloadDocument', 'showLoadingSpinner', 'deleteDocument']),
    ...mapActions('workflowQueueStore', ['setTableStateField']),
    ...mapActions(StickyStoreNames.DocumentsToStore, [StickySettingsActions.SetStickyStateField]),
    ...mapActions('userPreferencesStore', ['addSuppressedConfirmation', 'removeSuppressedConfirmation', 'setDocumentToStoreTableFilters', 'setDocumentsToStoreTableSortProperties']),
    async initialise(this: any): Promise<void> {
      try {
        this._isLoading = true;
        this.permissionData = await DocumentsToStoreService.getDocumentsToStoreAsync(this.showBatchNumber);
        if (this.permissionData) {
          if (!this.$route.params.id) {
            this.documentData = this.permissionData.myDocuments.documentData || [];
            this.documentColumns = this.permissionData.myDocuments.documentColumns || [];

            this.fileTypeWhiteList = this.permissionData?.fileUploadSettings?.fileExtensionWhiteList.map((type: string) => `.${type}`).join(',');
            this.fileUploadSizeLimitMb = this.permissionData?.fileUploadSettings?.fileSizeLimitMb;
            this.maximumFileUploadCount = this.permissionData?.fileUploadSettings?.maximumFileUploadCount;
            this.documentsToStoreDocumentTypeId = this.permissionData?.documentsToStoreDocumentTypeId;
          }
          this.initialiseTreeData();
        }
      } catch (error) {
        this.$log(error);
      } finally {
        this._isLoading = false;
      }
    },
    async reloadTreeView() {
      this.permissionData = await DocumentsToStoreService.getDocumentsToStoreAsync(this.showBatchNumber);
      this.initialiseTreeData();
      this.getNode(null, this.selectedDocumentType);
    },
    toggleShowBatchNumber(this: any, value: boolean) {
      const tableFilters = this.getDocumentToStoreTableFilters();
      tableFilters.includeBatchNumber = value;
      this.setDocumentToStoreTableFilters(tableFilters);
      this.getDocuments(this.selectedDocumentType);
    },
    toggleShowMultiSelect(this: any, value: boolean) {
      const tableFilters = this.getDocumentToStoreTableFilters();
      tableFilters.showMultiSelect = value;
      this.setDocumentToStoreTableFilters(tableFilters);
      if (!value) {
        this.selectedDocumentIds = [];
      }
    },
    onShowFilters(this: any, _: string, value: any) {
      if (!value) {
        this.pinFilter = false;
      }
      this.showFilters = value;
    },
    navigate(this: any, node: any): void {
      this.selectedDocumentType = node.data.id;
      this.reloadTreeView();
    },
    getNode(this: any, tree: any, id: any): void | undefined {
      id = id || DocumentTypes.MyDocuments;
      const node = this.$refs.tree.find({
        data: { id }
      });
      if (!node) {
        return;
      }
      this.selectedDocumentType = id;
      this.selectedNodeText = node[0]?.data.text;
      this.selectNode(node);
      this.getDocuments(id);
    },
    initialiseTreeData(this: any): any {
      const documentTypes = this.permissionData.documentTypes;
      if (documentTypes?.length > 0) {
        this.dynamicTreeData = documentTypes
          .filter((x: any) => x.id !== this.documentsToStoreDocumentTypeId)
          .map((x: any) => {
            return {
              text: x.description,
              data: { icon: 'folder-open', id: x.id, documentsCount: x.documentsCount },
              state: {
                visible: true,
                selectable: true
              }
            };
          });
      }
      if (this.$refs.tree) {
        this.$refs.tree.setModel(this.treeData);
      }
    },
    async getDocuments(this: any, id: string): Promise<void> {
      try {
        this.isDataLoading = true;
        this.showLoadingSpinner(true);
        switch (id) {
          case DocumentTypes.MyDocuments:
            this.documentType = await DocumentsToStoreService.getMyDocumentsAsync(this.showBatchNumber);
            break;
          case DocumentTypes.EveryonesDocuments:
            this.documentType = await DocumentsToStoreService.getEveryonesDocumentsAsync(this.showBatchNumber);
            break;
          default:
            const documentTypeId = Number(id);
            if (!documentTypeId) {
              return;
            }
            this.documentType = await DocumentsToStoreService.getDocumentsByDocumentTypeAsync(documentTypeId, this.showBatchNumber);
            break;
        }
        this.documentColumns = this.documentType.documentColumns;
        this.documentColumns.forEach((column: any, index: number) => {
          column.tdAttr = this.getCellId;
          this.$set(this.documentData, index, column);
        });
        this.documentData = this.documentType.documentData;
        if (!this.documentColumns.some((x: any) => x.key === this.getDocumentsToStoreTableSortProperties().sortBy)) {
          this.setDocumentsToStoreTableSortProperties({ fieldName: 'sortBy', fieldValue: 'storedTime' });
          this.setDocumentsToStoreTableSortProperties({ fieldName: 'sortDesc', fieldValue: true });
        }
        this.sortProperties = this.getDocumentsToStoreTableSortProperties();
      } catch (error) {
        this.$log(error);
        this.showLoadingSpinner(false);
      } finally {
        this.isDataLoading = false;
      }
    },
    onTableItemsChanged(this: any) {
      const filteredItem = this.$refs?.documentsTable?.filteredItems[0];
      if (!filteredItem) {
        return;
      }
      this.selectedDocument = filteredItem;
    },
    onRowClicked(this: any, item: any) {
      this.viewDocument(item);
    },
    onDoubleClick(this: any) {
      if (this.selectedDocument?.documentId && this.documentType.documentTypeId && !this.anyDocumentsSelected) {
        this.storeDocument(this.selectedDocument?.documentId, this.documentType.documentTypeId);
      }
    },
    onItemsFilteredOrSorted(filteredItems: any) {
      this.filteredItems = filteredItems;
    },
    onSortByChanged(fieldName: any, fieldValue: any) {
      if (fieldValue) {
        this.setDocumentsToStoreTableSortProperties({ fieldName, fieldValue });
      }
    },
    onSortDescChanged(fieldName: any, fieldValue: any) {
      this.setDocumentsToStoreTableSortProperties({ fieldName, fieldValue });
    },
    async loadDocument(this: any) {
      this.unloadDocument();
      if (document) {
        this.setDocumentSearchModel({
          cabinetId: Cabinet.IncomingDocuments,
          documentId: this.selectedDocument.documentId,
          documentTypeId: this.documentType.documentTypeId
        } as BaseDocumentSearchModel);
        await this.loadPage(1);
      } else {
        this.showLoadingSpinner(false);
      }
    },
    viewDocument(this: any, item: any): void {
      this.selectedDocument = item;
    },
    onDeleteDocument(this: any, row: any) {
      this.$bvModal
        .msgBoxConfirm('Are you sure you want to delete this document?', {
          title: 'Are you sure?',
          okVariant: 'danger',
          okTitle: 'Yes',
          cancelVariant: 'primary',
          cancelTitle: 'No'
        })
        .then(async (result: boolean) => {
          if (result) {
            const model = {
              cabinetId: Cabinet.IncomingDocuments,
              documentId: row.item.documentId,
              documentTypeId: this.documentType.documentTypeId
            } as BaseDocumentSearchModel;
            await this.deleteDocument(model);
            this.reloadTreeView();
          }
        });
    },
    selectedRowClass(item: any, type: any): string | undefined {
      if (!item || type !== 'row') {
        return;
      }

      if (this.documentIsBeingViewed(item)) {
        return 'table-success';
      }
    },
    documentIsBeingViewed(this: any, item: any): boolean {
      return this.documentSearchModel?.documentId === item.documentId && this.documentSearchModel?.cabinetId.toString() === Cabinet.IncomingDocuments;
    },
    validateFileType(this: any, file: any): boolean {
      const filenameSplitArray = file.name.split('.');
      const fileType = filenameSplitArray[filenameSplitArray.length - 1];
      return this.fileTypeWhiteList.includes(fileType.toLowerCase());
    },
    validateFileSize(this: any, file: any): boolean {
      const fileSizeMB = Math.ceil(file.size / (1024 * 1024));
      return fileSizeMB <= this.fileUploadSizeLimitMb;
    },
    getErrorMessage(this: any, files: any, isUnsupportedFileType: boolean | undefined): string {
      if (files.length < 1) {
        return '';
      }
      const fileNames = this.getFileNamesFromFiles(files);
      const multipleFiles = files.length > 1;
      const postFixMessage = isUnsupportedFileType ? `not${multipleFiles ? '' : ' a'} supported file type${multipleFiles ? 's' : ''}` : 'too large to upload';
      return `<p class="text-danger">The file${multipleFiles ? 's' : ''} ${fileNames} ${multipleFiles ? 'are' : 'is'} ${postFixMessage}.</p>`;
    },
    getFileNamesFromFiles(this: any, files: any): string {
      return [
        ...files.map((file: any) => {
          return file.file.name;
        })
      ].join(', ');
    },
    addErrorDetailsToConfirmationMessage(this: any, confirmationMessage: string, unsupportedError: string, largeFileErrorMessage: string): string {
      const note = `
 <div>
     <b>Note:</b>
     <p class="text-wrap text-break">File types supported by ${MStoreConstants.AppName} are ${this.fileTypeWhiteList}
     , the maximum single file size is ${this.fileUploadSizeLimitMb}MB
     and you may upload a maximum of ${this.maximumFileUploadCount} files in a batch</p>
   </div>`;
      return `${confirmationMessage} ${unsupportedError} ${largeFileErrorMessage} ${note}`;
    },
    async addFiles(this: any, type: string, event: any) {
      try {
        this.onDragLeave(type);
        const droppedFiles = event?.dataTransfer?.files || event?.target?.files;
        if (!droppedFiles) {
          return;
        }
        let allowUpload = type === DocumentTypes.MyDocuments || type === DocumentTypes.EveryonesDocuments;

        if (!allowUpload) {
          try {
            allowUpload = allowUpload || (await DocumentsToStoreService.getAllowUploadToDocumentTypeAsync(Number(type)));
          } catch (error) {
            this.$log(`Unable to determine if upload is allowed for given document type: ${type}`, error);
          }
        }

        if (!allowUpload) {
          SnotifyConfiguration.showNotification(NotificationConstants.UploadToDocumentTypeNotAllowed, NotificationPresentationType.UserActionRequired);
          return;
        }
        const unsupportedFiles = [] as any[];
        if (droppedFiles.length > this.maximumFileUploadCount) {
          const message = `<p class="text-danger">You have selected ${droppedFiles.length} files</p>`;
          const informationModalSettings: InformationModalSettings = {
            title: 'Too many files selected',
            isHtml: true,
            okVariant: ColourVariantType.Danger,
            okTitle: 'OK'
          };
          await this.showInformationModalAsync(this.$bvModal, this.addErrorDetailsToConfirmationMessage(message, '', ''), informationModalSettings);
          return;
        }

        [...droppedFiles].forEach((file) => {
          const isValidFileType = this.validateFileType(file);
          const isValidFileSize = this.validateFileSize(file);
          if (isValidFileType && isValidFileSize) {
            this.supportedFiles.push({ file, type, progress: 0 } as FileUploadModel);
          } else {
            unsupportedFiles.push({
              file,
              type,
              progress: 0,
              isValidFileType,
              isValidFileSize
            });
          }
        });

        if (this.supportedFiles.length > 0 || unsupportedFiles.length > 0) {
          const folderName = this.treeData.find((node: any) => node.data.id === type)?.text;
          const userConfirmation = await this.haveUserConfirmationForUpload(unsupportedFiles, folderName);
          if (userConfirmation) {
            this.showFileUploadModal = true;
            const uploadCompleted = await new Promise((resolve, reject): void => {
              this.supportedFiles.forEach(async (file: any, index: number, array: any) => {
                const uploadmodel = {
                  formFile: file.file,
                  isDocumentToStoreDocument: [DocumentTypes.MyDocuments, DocumentTypes.EveryonesDocuments].includes(type),
                  isMyDocument: DocumentTypes.MyDocuments === type
                } as DocumentToStoreUploadModel;
                if (!isNaN(Number(type))) {
                  uploadmodel.documentTypeId = Number(type);
                }
                DocumentsToStoreService.uploadDocumentsToStoreAsync(uploadmodel, (event: any) => {
                  file.progress = Math.round((100 * event.loaded) / event.total);
                })
                  .then(async (response: any) => {
                    const pdfPermissionOnlyEncryptionConfirmation = this.isConfirmationSupressed(this.pdfPermissionOnlyEncryptionConfirmation);
                    if (response.pdfPermissionOnlyEncryptionRemoved && !pdfPermissionOnlyEncryptionConfirmation) {
                      const message = `
                        <div class="text-center">
                          <div class="text-left">
                            <p class="mb-3">
                              The uploaded PDF contained <strong>permission-only encryption</strong> that restricted 
                              certain actions such as:
                            </p>
                            <ul class="mb-3">
                              <li>Printing the document</li>
                              <li>Copying text or images</li>
                              <li>Modifying the content</li>
                              <li>Adding annotations</li>
                            </ul>
                            <p class="mb-3">
                              This encryption has been <strong>removed</strong> to ensure full 
                              compatibility with ${MStoreConstants.AppName}'s features. Document permissions will now be controlled by ${MStoreConstants.AppName}'s security settings.
                            </p>
                          </div>
                        </div>
                      `;
                      const informationModalSettings: InformationModalSettings = {
                        title: 'PDF Security Settings Modified',
                        isHtml: true,
                        okVariant: ColourVariantType.Primary,
                        okTitle: 'I Understand',
                        showCheckBox: true,
                        callBack: this.setDontAskMeAgainRemovePdfEncryption
                      };
                      await this.showInformationModalAsync(this.$bvModal, message, informationModalSettings);
                    }
                    file.uploaded = true;
                  })
                  .catch((error: any) => {
                    file.error = true;
                    this.handleErrorResponse(error, file.file.name, folderName);
                  })
                  .finally(() => {
                    if (this.supportedFiles.every((file: any) => file.uploaded || file.error)) {
                      resolve(true);
                    }
                  });
              });
            });
            if (uploadCompleted) {
              const uploadedFiles = this.supportedFiles.filter((file: any) => file.progress === 100 && !file.error);
              if (uploadedFiles.length > 0) {
                const fileNames = this.getFileNamesFromFiles(uploadedFiles);
                const multipleFiles = uploadedFiles.length > 1;
                const successMessage = `The file${multipleFiles ? 's' : ''} ${fileNames} ${multipleFiles ? 'have' : 'has'} been uploaded to ${folderName}`;
                SnotifyConfiguration.showSuccess(successMessage);
              }
              this.showFileUploadModal = false;
              this.selectedDocumentType = type;
              this.reloadTreeView();
            }
          }
        }
      } catch (error) {
        this.$log(error);
        this.showFileUploadModal = false;
      } finally {
        this.clearFiles();
      }
    },

    async haveUserConfirmationForUpload(this: any, unsupportedFiles: any[], folderName: string): Promise<boolean> {
      const confirmationModal: any = this.getUploadConfirmationMessage(unsupportedFiles, folderName);

      if (this.supportedFiles.length > 0) {
        const userConfirmationSuppressed = this.isConfirmationSupressed(this.uploadFilesConfirmation);
        let userHasConfirmation = false;
        if (!userConfirmationSuppressed) {
          const confirmationModalSettings: ConfirmationModalSettings = {
            isHtml: true,
            showCheckBox: true,
            callBack: this.setDontAskMeAgain
          };
          userHasConfirmation = await this.showConfirmationModalAsync(this.$bvModal, confirmationModal.message, confirmationModalSettings);
          return userHasConfirmation;
        } else if (userConfirmationSuppressed && unsupportedFiles.length !== 0) {
          const confirmationModalSettings: ConfirmationModalSettings = {
            isHtml: true
          };
          userHasConfirmation = await this.showConfirmationModalAsync(this.$bvModal, confirmationModal.message, confirmationModalSettings);
          return userHasConfirmation;
        }
      } else if (unsupportedFiles.length > 0) {
        const informationModalSettings: InformationModalSettings = {
          title: confirmationModal.title,
          isHtml: true,
          okVariant: ColourVariantType.Danger,
          okTitle: 'OK'
        };
        await this.showInformationModalAsync(this.$bvModal, confirmationModal.message, informationModalSettings);
        return false;
      }

      return true;
    },

    getUploadConfirmationMessage(this: any, unsupportedFiles: any[], folderName: string): string {
      const confirmationModal: any = { title: '', message: '' };
      if (this.supportedFiles.length > 0) {
        const fileNames = [
          ...this.supportedFiles.map((file: any) => {
            return `<li>${file.file.name}</li>`;
          })
        ].join('');
        const fileString = `file${this.supportedFiles.length > 1 ? 's' : ''}`;

        confirmationModal.message = `<p>You are about to upload the ${fileString}: <br /> <ul> ${fileNames} </ul>
           ${fileString.capitalizeFirstLetter()} will be uploaded to ${folderName}. <p>`;
      }

      if (unsupportedFiles.length > 0) {
        const invalidFileTypeFiles = unsupportedFiles.filter((file) => !file.isValidFileType);
        const invalidFileSizeFiles = unsupportedFiles.filter((file) => !file.isValidFileSize);
        confirmationModal.title =
          invalidFileTypeFiles.length > 0 && invalidFileSizeFiles.length > 0
            ? 'Unsupported files and maximum allowed file size exceeded'
            : invalidFileTypeFiles.length > 0
            ? 'Unsupported file type'
            : invalidFileSizeFiles.length > 0
            ? 'Maximum file size exceeded'
            : '';
        const unsupportedFileTypeErrorMessage = this.getErrorMessage(invalidFileTypeFiles, true);
        const largeFileErrorMessage = this.getErrorMessage(invalidFileSizeFiles, false);

        confirmationModal.message = this.addErrorDetailsToConfirmationMessage(confirmationModal.message, unsupportedFileTypeErrorMessage, largeFileErrorMessage);
      }
      return confirmationModal;
    },

    uploadfile(this: any, delay: number, index: number): Promise<any> {
      return new Promise((resolve) => setTimeout(() => resolve(delay + 10), 500 * index));
    },
    handleErrorResponse(this: any, error: any, fileName: string, folderName: string) {
      const errorResponse = error as MStoreExceptionResponseModel;
      if (HttpResponseCodeConstants.handledHttpResponseCodes.includes(error?.status)) {
        SnotifyConfiguration.showNotification(`Failed to upload the file '${fileName}'. ${errorResponse.notification}`, errorResponse.presentationType);
        return;
      } else {
        const errorMessage = `Unable to upload the file ${fileName} to ${folderName},
        there may be an issue with the file, please check it. `;
        SnotifyConfiguration.showNotification(errorMessage, errorResponse.presentationType);
      }
    },
    removeFile(this: any, file: any) {
      this.supportedFiles = this.supportedFiles.filter((f: any) => {
        return f !== file;
      });
    },
    onPickFile(this: any) {
      this.$refs.fileUpload.click();
    },
    onFilePicked(this: any, event: any) {
      const targetFiles = event.target.files;
      if (!targetFiles) {
        return;
      }
      [...targetFiles].forEach((f) => {
        this.supportedFiles.push({ file: f, type: 'default' });
      });
    },
    onDragOver(this: any, id: any) {
      const node = this.$refs.tree.find({
        data: { id }
      });
      if (!node) {
        return;
      }
      node[0]?.vm?.$el?.classList?.add('drag-highlight');
    },
    onDragLeave(this: any, id: any) {
      const node = this.$refs.tree.find({
        data: { id }
      });
      if (!node) {
        return;
      }
      node[0]?.vm?.$el?.classList?.remove('drag-highlight');
    },
    onTreeViewRefreshClicked(this: any) {
      this.reloadTreeView();
    },
    clearFiles(this: any) {
      this.supportedFiles = [];
      this.$refs.fileUpload.value = null;
    },
    storeDocument(this: any, documentId: number, documentTypeId: number) {
      this.unloadDocument();
      this.$router.push({
        name: DocumentsToStore.DocumentsToStore.name,
        params: { documentId, documentTypeId }
      });
    },
    updateSelectionAfterDocumentDeletion(this: any, deletedDocumentId: number) {
      const index = this.documentData.findIndex((x: any) => x.documentId === deletedDocumentId);
      let filteredIndex = this.filteredItems.findIndex((x: any) => x.documentId === deletedDocumentId);
      if (index >= 0 && filteredIndex >= 0) {
        this.documentData.splice(index, 1);
        this.filteredItems.splice(filteredIndex, 1);

        if (this.selectedDocument?.documentId === deletedDocumentId) {
          filteredIndex = Math.min(filteredIndex, this.filteredItems.length - 1);

          this.selectedDocument = filteredIndex >= 0 ? this.filteredItems[filteredIndex] : null;
        }
      }
      this.reloadTreeView();
    },
    documentInWorkflow(this: any, item: any) {
      return item.inWorkflow;
    },
    deleteDocumentTooltip(this: any, item: any): string {
      if (!this.documentIsBeingViewed(item)) {
        return NotificationConstants.DocumentCannotBeDeletedUnlessItsBeingViewed;
      }

      return !this.documentActions?.delete
        ? NotificationConstants.NoDeletePermissionForDocument
        : this.document.inWorkflow
        ? NotificationConstants.CannotDeleteDocumentLinkedToWorkflow
        : 'Delete Document';
    },
    bulkDeleteDocumentTooltip(this: any): string {
      return !this.documentActions?.delete ? NotificationConstants.NoDeletePermissionForDocument : 'Delete Selected Documents';
    },
    setDontAskMeAgain(this: any, event: any) {
      if (event) {
        this.addSuppressedConfirmation(this.uploadFilesConfirmation);
      } else {
        this.removeSuppressedConfirmation(this.uploadFilesConfirmation);
      }
    },
    setDontAskMeAgainRemovePdfEncryption(this: any, event: any) {
      if (event) {
        this.addSuppressedConfirmation(this.pdfPermissionOnlyEncryptionConfirmation);
      } else {
        this.removeSuppressedConfirmation(this.pdfPermissionOnlyEncryptionConfirmation);
      }
    },
    getCellId(this: any, value: any, columnKey: any, rowData: any) {
      return { id: `${rowData.documentId}-${columnKey}` };
    },
    getTooltipColumnKeys(this: any, rowData: any) {
      return Object.keys(rowData).filter((rowDataKey) => this.tooltipColumnKeys.find((tooltipKey: string) => tooltipKey === rowDataKey));
    },
    async onDeleteSelectedDocuments(this: any) {
      if (this.selectedDocumentIds == null || this.selectedDocumentIds.length === 0) {
        return;
      }

      const result = await this.hasDeleteConfirmedAsync(this.$bvModal, `Are you sure you want to delete the ${this.selectedDocumentsCountMessage}?`);

      if (!result) {
        return;
      }

      this.showBulkDeleteModal = true;

      const batchSize = 10;
      const documentTypeId = this.documentType.documentTypeId;
      const documentIds = this.selectedDocumentIds;
      const apiResults: NotificationModel[] = [];

      for (let i = 0; i < documentIds.length; i += batchSize) {
        const batch = documentIds.slice(i, i + batchSize);
        const bulkDeleteRequestModel: DocumentsToStoreBulkDeleteRequestModel = {
          documentTypeId,
          documentIds: batch
        };
        try {
          const apiResult: NotificationModel = await ApiConfiguration.api().documentsToStore.documentsToStoreDocumentsDelete(bulkDeleteRequestModel);

          if (apiResult && apiResult.hasErrorMessages) {
            SnotifyConfiguration.showNotification(apiResult.firstErrorMessage ?? 'An unknown error occurred.', NotificationPresentationType.UserActionRequired);
            this.showBulkDeleteModal = false;
            return;
          }

          apiResults.push(apiResult);
        } catch (error) {
          this.$log(error);
        }
      }

      this.showBulkDeleteModal = false;

      if (this.selectedDocumentIds.length === 1 && apiResults.some((result: NotificationModel) => result.hasWarningMessages)) {
        SnotifyConfiguration.showNotification(apiResults[0]?.messages?.[0]?.message ?? 'The selected document could be deleted.', NotificationPresentationType.UserActionRequired);
      }

      if (this.selectedDocumentIds.length > 1 && apiResults.length > 0 && apiResults.some((result: NotificationModel) => result.hasWarningMessages)) {
        SnotifyConfiguration.showNotification(
          'Not all selected documents could be deleted. Please retry by deleting the documents individually for more details.',
          NotificationPresentationType.UserActionRequired
        );
      }

      if (apiResults.length > 0 && !apiResults.some((result: NotificationModel) => result.hasWarningMessages)) {
        SnotifyConfiguration.showSuccess(`${this.selectedDocumentsCountMessage} deleted successfully.`);
      }

      this.selectedDocumentIds = [];
      this.reloadTreeView();
    },
    onRowSelected(this: any, itemKey: string) {
      this.selectedDocumentIds = SelectableTableUtils.DefaultSelectItem(this.selectedDocumentIds, itemKey);
    },
    onRowsSelected(this: any, itemKeys: string[]) {
      this.selectedDocumentIds = SelectableTableUtils.DefaultSelectItems(this.selectedDocumentIds, itemKeys);
    }
  },
  computed: {
    ...mapGetters('documentViewStore', ['documentSearchModel', 'isPageLoadingOrConverting', 'document', 'deletedDocumentId', 'documentActions', 'isDeleting', 'isPageLoading']),
    ...mapGetters(StickyStoreNames.DocumentsToStore, [StickySettingsGetters.GetStickyStateField]),
    ...mapGetters('userPreferencesStore', ['isConfirmationSupressed', 'getDocumentToStoreTableFilters', 'getDocumentsToStoreTableSortProperties']),
    pinFilter: {
      get(this: any): boolean {
        return this.getDocumentToStoreTableFilters().pinFilter;
      },
      set(this: any, value: boolean) {
        const tableFilters = this.getDocumentToStoreTableFilters();
        tableFilters.pinFilter = value;
        this.setDocumentToStoreTableFilters(tableFilters);
      }
    },
    showBatchNumber: {
      get(this: any) {
        return this.getDocumentToStoreTableFilters().includeBatchNumber;
      },
      set(this: any, value: boolean) {
        const tableFilters = this.getDocumentToStoreTableFilters();
        tableFilters.includeBatchNumber = value;
        this.setDocumentToStoreTableFilters(tableFilters);
        this.getDocuments(this.selectedDocumentType);
      }
    },
    showMultiSelect: {
      get(this: any) {
        const tableFilters = this.getDocumentToStoreTableFilters();
        if (!tableFilters.hasOwnProperty('showMultiSelect')) {
          this.$set(tableFilters, 'showMultiSelect', false);
        }
        return tableFilters.showMultiSelect ?? false;
      },
      set(this: any, value: boolean) {
        const tableFilters = this.getDocumentToStoreTableFilters() || {
          includeBatchNumber: false,
          pinFilter: false,
          searchTerm: '',
          showMultiSelect: false
        };
        this.$set(tableFilters, 'showMultiSelect', value);
        this.setDocumentToStoreTableFilters(tableFilters);
      }
    },
    defaultTreeData(this: any): object {
      return [
        {
          text: 'My Documents',
          data: {
            icon: 'folder-open',
            id: DocumentTypes.MyDocuments,
            documentsCount: this.permissionData?.myDocuments.documentData.length
          },
          state: {
            visible: this.permissionData?.canAccessMyDocuments,
            selectable: true
          }
        },
        {
          text: `Everyone's Documents`,
          data: {
            icon: 'folder-open',
            id: DocumentTypes.EveryonesDocuments,
            documentsCount: this.permissionData?.documentTypes.filter((x: any) => x.id === this.documentsToStoreDocumentTypeId)[0].documentsCount
          },
          state: {
            visible: this.permissionData?.canAccessEveryonesDocuments,
            selectable: true
          }
        }
      ];
    },
    treeData(this: any): object {
      return [...this.defaultTreeData, ...this.dynamicTreeData];
    },
    _isLoading: {
      get(this: any) {
        return this.loading;
      },
      set(this: any, value: boolean) {
        this.$emit('update:loading', value);
      }
    },
    progress(this: any) {
      return (index: number) => {
        return this.supportedFiles[index].progress;
      };
    },
    deleteDocumentDisabled(this: any) {
      return !this.documentActions.delete || this.isPageLoadingOrConverting || this.isDeleting;
    },
    emptyText(this: any) {
      return this.isDataLoading ? 'Loading documents...' : 'There are no documents to show.';
    },
    selectedDocumentToStoreDocumentType(this: any) {
      return this.getStickyStateField ? this.getStickyStateField(StickySettingsFields.SelectedDocumentToStoreDocumentType) : null;
    },
    selectedDocumentsCountMessage(this: any) {
      return !this.selectedDocumentIds || this.selectedDocumentIds.length === 0
        ? ''
        : this.selectedDocumentIds.length > 1
        ? `${this.selectedDocumentIds.length} selected documents`
        : 'selected document';
    },
    isDeleteSelectedDocumentsDisabled(this: any) {
      return !this.documentActions.delete || this.isPageLoading || this.isDeleting || !this.selectedDocumentIds || this.selectedDocumentIds.length === 0;
    },
    anyDocumentsSelected(this: any): boolean {
      return this.selectedDocumentIds && this.selectedDocumentIds.length > 0;
    }
  },
  watch: {
    // tslint:disable-next-line:object-literal-key-quotes
    isDataLoading(this: any) {
      const state: DataLookupState = this.isDataLoading ? DataLookupState.Loading : this.documentData?.length > 0 ? DataLookupState.HasData : DataLookupState.NoData;

      this.setStickyStateField({ field: StickySettingsFields.DocumentsLookupState, value: state });
    },
    // tslint:disable-next-line:object-literal-key-quotes
    selectedDocument(this: any) {
      if (this.selectedDocument) {
        this.loadDocument();
      } else {
        this.setStickyStateField({
          field: StickySettingsFields.DocumentsLookupState,
          value: DataLookupState.NoData
        });
      }
    },
    'document.totalPages'(this: any) {
      const document = this.documentData.find((x: any) => x.documentId === this.document.id);
      if (document) {
        document.totalPages = this.document.totalPages;
      }
    },
    // tslint:disable-next-line:object-literal-key-quotes
    deletedDocumentId(this: any, deletedDocumentId: number) {
      if (deletedDocumentId) {
        this.updateSelectionAfterDocumentDeletion(deletedDocumentId);
      }
    },
    // tslint:disable-next-line:object-literal-key-quotes
    selectedDocumentType(this: any) {
      if (this.selectedDocumentType) {
        this.setStickyStateField({
          field: StickySettingsFields.SelectedDocumentToStoreDocumentType,
          value: this.selectedDocumentType
        });
      }
    }
  },
  mounted(this: any) {
    this.initialise();
    this.showFilters = this.getDocumentToStoreTableFilters().pinFilter;
  },
  created(this: any) {
    this.selectedDocumentType = this.selectedDocumentToStoreDocumentType == null ? DocumentTypes.MyDocuments : this.selectedDocumentToStoreDocumentType;
    this.fileUploadSizeLimitMb = 1;
    this.fileTypeWhiteList = '';
    this.maximumFileUploadCount = 1;
    this.uploadFilesConfirmation = 'uploadFilesConfirmation';
    this.pdfPermissionOnlyEncryptionConfirmation = 'pdfPermissionOnlyEncryptionConfirmation';
    this.tooltipColumnKeys = ['status'];
  },
  components: {
    MStoreTable,
    LoadingSpinner,
    TreeViewHeader,
    MStoreFormCheckbox,
    MStoreFilter,
    MStoreProgressModal
  }
});
